import { Box } from "@mui/material";
import { DateHelper } from "../../../helpers/dateHelper";
import { LabelBadge } from "../../../shared/components/common/labelBadge";

export function InitializeColumnsPromotionalCode() {
  return [
    {
      header: 'Code Name',
      accessorKey: 'code',
      enableClickToCopy: true,
      size: 80
    },
    {
      header: 'Code type',
      accessorKey: 'type',
      Cell: ({ cell }) => {
        return cell?.getValue() === 1 ? 'Fixed' : 'Percentage';
      },
      size: 80
    },
    {
      header: 'Maximum Redemptions',
      accessorKey: 'maxTotalUsage',
      size: 160,
    },
    {
      header: 'Maximum Redemptions per User',
      accessorKey: 'maxUsagePerUser',
      size: 160,
    },
    {
      header: 'Start Date',
      accessorKey: 'startDate',
      Cell: ({ cell }) => {
        return DateHelper.formatDate(cell?.getValue());
      },
      size: 80
    },
    {
      header: 'Expiry Date',
      accessorKey: 'expiryDate',
      Cell: ({ cell }) => {
        return DateHelper.formatDate(cell?.getValue());
      },
      size: 80
    },
    {
      header: 'Created Date',
      accessorKey: 'createdAt',
      Cell: ({ cell }) => {
        return DateHelper.formatDate(cell?.getValue());
      },
      size: 80
    },
    {
      header: 'Active/Deactive',
      accessorKey: 'isActive',
      Cell: ({ cell }) => {
        return (
          <Box className="flex flex-auto justify-start items-center">
            {cell?.getValue() ? (
              <LabelBadge label={'Active'}></LabelBadge>
            ) : (
              <LabelBadge
                classList={'!bg-red-200 !text-red-500'}
                label={'Deactive'}></LabelBadge>
            )}
          </Box>
        );
      },
    },

  ];
}